import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import {
    MediaStorageIcon,
    ContentDeliveryIcon,
    DesignSpecIcon,
    StreamPlayerIcon,
} from "../../../../app-constants"

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 1600 },
        items: 4
    },
    desktop: {
        breakpoint: { max: 1599, min: 1400 },
        items: 4
    },
    tabletlandscape: {
        breakpoint: { max: 1399, min: 1200 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1199, min: 667 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 666, min: 0 },
        items: 1
    }
};

const Technologycreation = () => {
    return (
        <div className="technology_creation p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Best Technology for The Creation of Live Streaming Apps</h2>
                        <p>Advances in technology have made live streaming apps possible. Specifically, the following technologies have helped live streaming app development:</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000}
                            arrows={false} className="carousel_solution">

                            <div className="featured_item">
                                <div className="creation_box">
                                    <div className="creation_img">
                                        {MediaStorageIcon}
                                    </div>
                                    <div className="creation_content">
                                        <h5>Media storage</h5>
                                        <p>Cloud providers like Google, Amazon, and Microsoft have made it possible to store media assets in a reliable and scalable manner.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="creation_box">
                                    <div className="creation_img">
                                        {ContentDeliveryIcon}
                                    </div>
                                    <div className="creation_content">
                                        <h5>Content Delivery Network (CDN)</h5>
                                        <p>A network of distributed servers to make content delivery easier for a dispersed audience.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="creation_box">
                                    <div className="creation_img">
                                        {DesignSpecIcon}
                                    </div>
                                    <div className="creation_content">
                                        <h5>Design Specifications</h5>
                                        <p>Advances in UI/UX design make it possible for users to intuitively use live streaming apps.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="creation_box">
                                    <div className="creation_img">
                                        {StreamPlayerIcon}
                                    </div>
                                    <div className="creation_content">
                                        <h5>Streaming Players</h5>
                                        <p>Advanced video players that adapt to platform and browser and give the best experience to users.</p>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Technologycreation